<template>
  <div class="advertisement">
    <div class="advertisement-header">
      <div class="advertisement-header-text">
        <h3>系统平台搭建</h3>
        <p>提供定制化的平台开发服务，根据需求打造功能丰富、高效的系统平台。</p>
        <div @click="handleClick">发布信息</div>
      </div>
    </div>
    <common type="4"></common>
  </div>
</template>

<script>
import common from "../components/common"
export default {
  components:{
    common
  },
  data(){
    return{
    }
  },
  methods:{
    handleClick(){
      this.$router.push({ path: "/publish", query: { type: "4" } });
    }
  }
}
</script>

<style scoped lang="less">
.fontdemo(@size,@family,@weight,@color){
  font-size:@size;
  font-family:@family;
  font-weight:@weight;
  color:@color
}
.advertisement{
  width: 100%;
  &-header{
    width: 100%;
    height: 600px;
    background: url("../assets/background4.png") no-repeat;
    background-size: cover;
    display: flex;
    justify-content: flex-end;
    &-text{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      margin-right: 190px;
      align-items: flex-end;
      h3{
        .fontdemo(47px, 'PingFangSC,PingFang SC', 600, #000000);
        margin: 0;
      }
      p{
        .fontdemo(30px, 'PingFangSC,PingFang SC', 400, #000000);
        margin: 22px 0 49px;
        max-width: 700px;
        line-height: 50px;
        text-align: right;
      }
      div{
        width: 154px;
        height: 52px;
        background: #4787F0;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        .fontdemo(18px, 'PingFangSC,PingFang SC', 500, #FFFFFF);
        cursor: pointer;
      }
    }
  }
}
</style>